import { useState } from 'react';
import { useAuth } from '../lib/useAuth';
import { FolderTree } from '../components/FolderTree';
import { FileViewer } from '../components/FileViewer';
import type { DriveItem } from '../lib/api';

/** Authenticated app shell: folder tree (configured shared folders only) + viewer. */
export function Home() {
  const { user, logout } = useAuth();
  const [selected, setSelected] = useState<DriveItem | null>(null);

  return (
    <div className="app">
      <header className="topbar">
        <span className="brand">view.go.art</span>
        <div className="spacer" />
        <span className="user">
          {user?.picture && <img src={user.picture} alt="" className="avatar" />}
          {user?.email}
        </span>
        <button className="btn btn-ghost" onClick={() => void logout()}>
          Sign out
        </button>
      </header>

      <div className="layout">
        <aside className="sidebar">
          <FolderTree selectedId={selected?.id ?? null} onSelect={setSelected} />
        </aside>
        <main className="viewer">
          <FileViewer item={selected} />
        </main>
      </div>
    </div>
  );
}
